<template>
  <base-material-card :icon="resource.icon" :title="title">
    <template v-slot:subtitle>
      <info-text :resource="resource" crud-type="list" />
    </template>
    <va-list :filters="filters" disable-export>
      <va-data-table :fields="fields" disable-clone disable-show>
        <template v-slot:[`item.actions`]="{ item }">
          <show-graylog-button :item="item" />
        </template>
      </va-data-table>
    </va-list>
  </base-material-card>
</template>

<script>
import InfoText from "@/components/helper/InfoText";
import i18n from "@/i18n";
import ShowGraylogButton from "@/resources/ssoConnections/components/ShowGraylogButton";

export default {
  components: { ShowGraylogButton, InfoText },
  props: ["resource", "title"],
  data() {
    return {
      fields: [
        { label: i18n.t("integrations.fields.code"), source: "code" },
        { label: i18n.t("integrations.fields.saml_idp"), source: "saml_idp" },
        { label: i18n.t("integrations.fields.saml_entity_id"), source: "saml_entity_id" },
        { label: i18n.t("integrations.fields.tenant"), source: "tenant.id" },
        { label: i18n.t("integrations.fields.updated_at"), type: "date", source: "updated_at" }
      ],
      filters: []
    };
  }
};
</script>
